import { HighchartsExportWrapper } from 'components/shared/Highcharts/HighchartsExportWrapper';
import { HighchartsReact } from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { sanitizeLocaleCode } from 'locales/utils';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { toHighchartsTheme } from 'utils/highcharts';

import type { GraphType, UnderlyingHistorics } from './UnderlyingHistoModels';
import { optionsFromJson } from './utils';

export const HighStock: FC<{
  historics: UnderlyingHistorics;
  graphType: GraphType;
  title: string;
}> = ({ historics, graphType, title }) => {
  const theme = useSgBsTheme();
  const intl = useIntl();
  const options = useMemo(() => {
    return optionsFromJson(historics, graphType, title, intl);
  }, [historics, graphType, title, intl]);

  Highcharts.setOptions({
    lang: {
      locale: sanitizeLocaleCode(intl.locale),
      rangeSelectorZoom: intl.formatMessage({ id: 'underlying.histograph.zoom' }),
    },
  });

  return (
    <HighchartsExportWrapper
      highchartsOptions={options}
      hasCopyToClipBoard={false}
      Chart={({ highchartsOptions, chartComponentRef }) => (
        <HighchartsReact
          ref={chartComponentRef}
          highcharts={Highcharts}
          constructorType="stockChart"
          options={highchartsOptions}
          containerProps={{ className: toHighchartsTheme(theme) }}
        />
      )}
    ></HighchartsExportWrapper>
  );
};
